import serverState from './services'

export const serverBaseUrl = serverState.api
export const isDebug = serverState.lnk === 'local'

const commitHash = process.env.CI_COMMIT_SHA
const appVersion = commitHash || (+new Date()).toString(16)
export const buildHash = (isDebug ? '' : appVersion)

export const appUrl = serverState.url

